import initInputValidator from '../global/inputValidator';
import { ready } from '../global/instantiate';
import initQuantitySelector from '../sections/cart/quantitySelector';

ready(() => {
  initInputValidator();
  initQuantitySelector();
});
